<!--  -->
<template>
  <div style="width: 100%;scroll-behavior: smooth;">
    <Header />

    <div class="content">
        <div class="one">
            <div class="left">
                <div class="banner">
                    <div class="banner-top">
                        <div class="title">成果简介</div>
                        <div class="more">更多 <i class="el-icon-right"></i></div>
                    </div>
                    <div class="down"></div>
                </div>
                <div class="content_sub">
                    <img class="sub-left" src="../../assets/img/chengguozhanshi/index-photo.png" alt="">
                    <div class="sub-right">
                        山东轻工职业学院是淄博市人民政府主办的全日制综合性高等职业学校。学校始建于1960年，其前身是山东省丝绸工业学校，2006年升格为山东丝绸纺织职业学院，2014年更名为山东轻工职业学院。学校设有纺织工程系、商务贸易系、机电工程系、国际时尚学院等10个二级系院，服装设计与工艺、人工智能技术应用、动漫制作技术等34个高职专业，在校生1.4万余人。
                    </div>
                </div>
            </div>
            <div class="middle">
                <div class="banner">
                    <div class="banner-top">
                        <div class="title">申报书</div>
                        <div class="more">更多 <i class="el-icon-right"></i></div>
                    </div>
                    <div class="down"></div>
                </div>
                <div class="content_sub">
                    <div class="list">
                        <div class="item">
                            <img class="item-img" src="../../assets/img/chengguozhanshi/shenbao-img.png" alt="">
                            <div class="item-title">成果曾获奖情况</div>
                        </div>
                        <div class="item">
                            <img class="item-img" src="../../assets/img/chengguozhanshi/shenbao-img.png" alt="">
                            <div class="item-title">成果简介及主要解决的教学问题</div>
                        </div>
                        <div class="item">
                            <img class="item-img" src="../../assets/img/chengguozhanshi/shenbao-img.png" alt="">
                            <div class="item-title">成果解决教学问题的方法</div>
                        </div>
                        <div class="item">
                            <img class="item-img" src="../../assets/img/chengguozhanshi/shenbao-img.png" alt="">
                            <div class="item-title">成果的创新点</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="right">
                <div class="banner">
                    <div class="banner-top">
                        <div class="title">成果报告</div>
                        <div class="more">更多 <i class="el-icon-right"></i></div>
                    </div>
                    <div class="down"></div>
                </div>
                <div class="content_sub">
                    <div class="list">
                        <div class="item">
                            <img class="item-img" src="../../assets/img/chengguozhanshi/chengguobaogao-one.png" alt="">
                            <div class="item-title">成果视频</div>
                        </div>
                        <div class="item">
                            <img class="item-img" src="../../assets/img/chengguozhanshi/chengguobaogao-two.png" alt="">
                            <div class="item-title">教学成果报告</div>
                        </div>
                        <div class="item">
                            <img class="item-img" src="../../assets/img/chengguozhanshi/chengguobaogao-three.png" alt="">
                            <div class="item-title">教学成果应用及效果</div>
                        </div>
                        <div class="item">
                            <img class="item-img" src="../../assets/img/chengguozhanshi/chengguobaogao-two.png" alt="">
                            <div class="item-title">其他成果质量报告</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="two">
            <div class="banner">
                <div class="banner-top">
                    <div class="title">支撑材料模块</div>
                    <div class="more">更多 <i class="el-icon-right"></i></div>
                </div>
                <div class="down"></div>
            </div>
            <div class="content_sub">
                <div class="list">
                    <div class="item">
                        <img class="item-img" src="../../assets/img/chengguozhanshi/cailiao1.png" alt="">
                        <div class="item-title">教学成果奖</div>
                    </div>
                    <div class="item">
                        <img class="item-img" src="../../assets/img/chengguozhanshi/cailiao2.png" alt="">
                        <div class="item-title">教改课题</div>
                    </div>
                    <div class="item">
                        <img class="item-img" src="../../assets/img/chengguozhanshi/cailiao3.png" alt="">
                        <div class="item-title">教学团队</div>
                    </div>
                    <div class="item">
                        <img class="item-img" src="../../assets/img/chengguozhanshi/cailiao4.png" alt="">
                        <div class="item-title">教学成果评价</div>
                    </div>
                    <div class="item">
                        <img class="item-img" src="../../assets/img/chengguozhanshi/cailiao5.png" alt="">
                        <div class="item-title">专业建设</div>
                    </div>
                    <div class="item">
                        <img class="item-img" src="../../assets/img/chengguozhanshi/cailiao6.png" alt="">
                        <div class="item-title">教程教材</div>
                    </div>
                    <div class="item">
                        <img class="item-img" src="../../assets/img/chengguozhanshi/cailiao7.png" alt="">
                        <div class="item-title">教学与实践</div>
                    </div>
                    <div class="item">
                        <img class="item-img" src="../../assets/img/chengguozhanshi/cailiao8.png" alt="">
                        <div class="item-title">学生成果获奖</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import Header from "./header.vue";
export default {
  data () {
    return {
    }
  },

  components: {
    Header
  }
}
</script>

<style  scoped lang="less">
.content {
    padding: 20px 2%;
    .banner {
        border-bottom: 1px solid #B3B3B3;
        position: relative;
        .banner-top {
            display: flex; 
            align-items: center;
            justify-content: space-between;
            margin-bottom: 10px;
            .title {
                font-weight: bold;
            }
            .more {
                color: #565656;
                font-size: 13px;
            }
        }
        .down {
            width: 10px;
            height: 10px;
            background-color: #f5f5f5;
            border-bottom: 1px solid #B3B3B3;
            border-right: 1px solid #B3B3B3;
            margin-left: 25px;

            transform: rotate(45deg);

            position: absolute;
            bottom: -6px;

            z-index: 10;
        }
    }
    .one {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .left {
            width: 55%;
            .content_sub {
                margin-top: 20px;
                background-color: #fff;
                height: 200px;

                display: flex;
                .sub-left {
                    width: 250px;
                }
                .sub-right {
                    flex: 1;
                    margin: 10px 15px;
                    line-height: 30px;
                    font-size: 14px;
                    color: #252525 ;
                    text-indent: 2em;
                }
            }
        }
        .middle {
            width: 20%;
            .content_sub {
                margin-top: 20px;
                height: 200px;
                .list {
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    .item {
                        height: 43px;
                        background-color: #fff;

                        display: flex;
                        align-items: center;
                        .item-img {
                            width: 27px;
                            height: 27px;

                            margin-left: 20px;
                        }
                        .item-title {
                            font-size: 13px;
                            margin-left: 5px;
                            font-weight: bold;
                        }
                    }
                }
            }
        }
        .right {
            width: 20%;
            .content_sub {
                margin-top: 20px;
                height: 200px;
                .list {
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    .item {
                        height: 43px;
                        background-color: #fff;

                        display: flex;
                        align-items: center;
                        .item-img {
                            width: 40px;
                            height: 100%;
                        }
                        .item-title {
                            font-size: 13px;
                            margin-left: 20px;
                            font-weight: bold;

                            color: #0527AF;
                        }
                    }
                }
            }
        }
    }

    .two {
        margin-top: 25px;
        .content_sub {
            margin-top: 20px;
            .list {
                display: flex;
                align-items: center;
                justify-content: space-between;
                flex-wrap: wrap;
                .item {
                    width: 24%;
                    background-color: #fff;
                    padding: 10px 0;

                    display: flex;
                    align-items: center;

                    margin-bottom: 15px;
                    .item-img {
                        margin-left: 20px;
                        width: 20px;
                        height: 20px;
                    }
                    .item-title {
                        margin-left: 15px;
                        font-size: 14px;
                    }
                }
            }
        }
    }
}
</style>
